export class PurchasingUnit {

  constructor(
    public order?: number,
    public unit?: string,
    public pid?: string,
    public internationalId?: string,
    public gevisMapping?: string,
    public contentQuantity?: number,
    public depth?: number,
    public length?: number,
    public width?: number,
    public weight?: number,
    public quantityMin?: number,
    public quantityMax?: number,
  ) {

  }
}
